import refs from '../helpers/refs'

class CSupportCards {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-support-cards]')
    .forEach(el => new CSupportCards(el))
})
